import {
  MenuItem,
  styled,
  Switch,
  Select,
  Tabs,
  Tab,
  Box,
  FormControlLabel,
} from '@mui/material';
import { memo, useMemo, useState } from 'react';
import { NumericFormat } from 'react-number-format';
import { Trans, useTranslation } from 'react-i18next';

import ImagesSwiper from 'components/ImagesSwiper';
import EditableNumberField from 'components/ui/editable-fields/EditableNumberField';
import NewDiscountTable from './NewDiscountTable';
import SimpleNumberField from 'components/ui/simple-fields/numeric-format/SimpleNumberField';
import DiscountPanel from './DiscountPanel';

const options = [
  {
    month: 1,
    payment: 100,
  },
  {
    month: 24,
    payment: 50,
  },
  {
    month: 36,
    payment: 30,
  },
];

export default memo(function NewDesign({
  homesData,
  selectedDiscount,
  priceForSquare,
  terassaPriceForSquare,
  handleChangePriceSquare,
  handleChangeTerassaPriceSquare,
  currency,
  sellPrice,
  handleChangeSellPrice,
  isrepaired,
  handleChange,
  discount,
  discountPercentage,
  homeData,
  startPriceTopOrder,
  handleChangeStartPriceOrder,
  startPricePercentage,
  handleChangeStartPricePercent,
  startPrice,
  handleChangeStartPrice,
  month,
  handleChangeMonth,
  setApplyDiscount,
  applyDiscount,
  formik,
  fullPrice,
  handleChangeDiscount,
  handleChangeDiscountPercentage,
  priceForMonth,
  handleChangePriceForMonth,
  isEnableCalc,
  setIsEnableCalc,
  percent,
  setPercent,
  calculations,
  setStartPrice,
  setStartPricePercentage,
  setDiscount,
  setDiscountPercentage,
  setSellPrice,
  setPriceForMonth,
  setMonth,
  setPriceForSquare,
  setSelectedDiscount,
  setStartPriceTopOrder,
  filters,
  setFilters,
  lastPayment,
  lastPaymentPercentage,
  handleChangeLastPayment,
  handleChangeLastPaymentPercentage,
}) {
  const { t } = useTranslation();
  const [selected, setSelected] = useState(0);
  const [discountList, setDiscountList] = useState([]);
  const home = homesData?.[selected];

  const onSelectDiscount = (val, type) => {
    setFilters((prv) => ({ ...prv, [type]: val }));
  };

  const payments = useMemo(() => {
    if (discountList?.length) {
      const list = new Set(discountList?.map((d) => d?.payment));
      return [...list];
    }
    return [];
  }, [discountList]);
  const months = useMemo(() => {
    if (discountList?.length) {
      const list = new Set(discountList?.map((d) => d?.month));
      return [...list];
    }
    return [];
  }, [discountList]);

  return (
    <div>
      <div className='mt-2'>
        <div className='grid grid-cols-1 gap-2'>
          <div className='rounded-2xl shadow-sm bg-white px-4 py-2'>
            <div className='flex justify-between items-center'>
              <div className='flex gap-2 whitespace-nowrap items-center'>
                <span className='text-sm font-medium text-[#64748B]'>
                  {t('shaxmatka.moreHomeDetails.month')}:
                </span>
                <div className='flex gap-2'>
                  {applyDiscount
                    ? months?.map((month, i) => (
                        <div key={i} className='relative'>
                          <button
                            style={{
                              background:
                                filters?.month == month ? '#7947f8' : '',
                              color: filters?.month == month ? '#FFF' : '',
                            }}
                            className={`px-3 py-1.5 relative text-sm font-semibold bg-gray-200 text-text-light rounded-full hover:bg-gray-300 transition-all ${
                              filters?.month == month ? 'shadow-md' : ''
                            }`}
                            onClick={() => onSelectDiscount(month, 'month')}
                          >
                            {month} {t('common.fields.simpleMonth')}
                          </button>
                          {filters?.month == month ? (
                            <button
                              onClick={() => onSelectDiscount(null, 'month')}
                              className='absolute -top-2 -right-2 flex items-center justify-center bg-white shadow-md rounded-full w-5 h-5'
                            >
                              <i className='bi bi-x font-bold' />
                            </button>
                          ) : (
                            ''
                          )}
                        </div>
                      ))
                    : options?.map((dis, i) => (
                        <button
                          key={i}
                          style={{
                            background: month == dis?.month ? '#7947f8' : '',
                            color: month == dis?.month ? '#FFF' : '',
                          }}
                          onClick={() => handleChangeMonth(dis?.month)}
                          className={`px-3 py-1.5 text-sm font-semibold bg-gray-200 text-text-light rounded-full hover:bg-gray-300 transition-all ${
                            month == dis?.month ? 'shadow-md' : ''
                          }`}
                        >
                          {dis?.month} {t('common.fields.simpleMonth')}
                        </button>
                      ))}
                </div>
              </div>
              <div>
                <div className='bg-gray-100 rounded-lg py-1 px-2'>
                  <div className='payment-item-label leading-3 text-sm  font-medium text-[#64748B]'>
                    {t('payment.add.contract.totalSum')}:
                  </div>
                  <NumericFormat
                    value={fullPrice}
                    allowNegative={false}
                    displayType={'text'}
                    thousandSeparator={' '}
                    decimalScale={3}
                    className='w-full text-right text-sm font-semibold text-text-light rounded-full'
                    suffix={currency == '1' ? ' $' : ' UZS'}
                  />
                </div>
              </div>
              <div className='flex gap-2 whitespace-nowrap items-center'>
                <span className='text-sm font-medium text-[#64748B]'>
                  {t('common.fields.startPrice')}:
                </span>
                {applyDiscount
                  ? payments?.map((payment, i) => (
                      <div key={i} className='relative'>
                        <button
                          style={{
                            background:
                              filters?.payment == payment ? '#7947f8' : '',
                            color: filters?.payment == payment ? '#FFF' : '',
                          }}
                          className={`px-3 py-1.5 text-sm font-semibold bg-gray-200 text-text-light rounded-full hover:bg-gray-300 transition-all ${
                            filters?.payment == payment ? 'shadow-md' : ''
                          }`}
                          onClick={() => onSelectDiscount(payment, 'payment')}
                        >
                          {payment}%
                        </button>
                        {filters?.payment == payment ? (
                          <button
                            onClick={() => onSelectDiscount(null, 'payment')}
                            className='absolute -top-2 -right-2 flex items-center justify-center bg-white shadow-md rounded-full w-5 h-5'
                          >
                            <i className='bi bi-x font-bold' />
                          </button>
                        ) : (
                          ''
                        )}
                      </div>
                    ))
                  : options?.map((dis, i) => (
                      <button
                        key={i}
                        style={{
                          background:
                            startPricePercentage == dis?.payment
                              ? '#7947f8'
                              : '',
                          color:
                            startPricePercentage == dis?.payment ? '#FFF' : '',
                        }}
                        onClick={() =>
                          handleChangeStartPricePercent(dis?.payment)
                        }
                        className={`px-3 py-1.5 text-sm font-semibold bg-gray-200 text-text-light rounded-full hover:bg-gray-300 transition-all  ${
                          startPricePercentage == dis?.payment
                            ? 'shadow-md'
                            : ''
                        }`}
                      >
                        {dis?.payment}%
                      </button>
                    ))}
              </div>
            </div>
          </div>
          <div>
            <NewDiscountTable
              setDiscountList={setDiscountList}
              applyDiscount={applyDiscount}
              startPrice={startPrice}
              setStartPrice={setStartPrice}
              currency={currency}
              startPricePercentage={startPricePercentage}
              setStartPricePercentage={setStartPricePercentage}
              discount={discount}
              setDiscount={setDiscount}
              discountPercentage={discountPercentage}
              setDiscountPercentage={setDiscountPercentage}
              sellPrice={sellPrice}
              setSellPrice={setSellPrice}
              priceForMonth={priceForMonth}
              setPriceForMonth={setPriceForMonth}
              month={month}
              setMonth={setMonth}
              discountId={formik.values?.discountId || null}
              fullPrice={fullPrice}
              setPriceForSquare={setPriceForSquare}
              square={homeData?.square}
              selectedDiscount={selectedDiscount}
              setSelectedDiscount={setSelectedDiscount}
              defaultStartPrice={homeData?.start}
              setStartPriceTopOrder={setStartPriceTopOrder}
              filters={filters}
              lastPayment={lastPayment}
            />
          </div>
        </div>
      </div>
      <div>
        <div className='flex w-full mt-4'>
          <div
            key={home?.id}
            className='images-wrapper !px-0 grid grid-cols-[850px,1fr] gap-4 !w-full !shadow-none'
          >
            <div className='w-[850px] bg-white !rounded-2xl !shadow-sm  !p-4'>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={selected} onChange={(_, v) => setSelected(v)}>
                  {homesData?.map((home, i) => (
                    <Tab
                      size='small'
                      key={home?.id}
                      value={i}
                      label={`№${home?.number}`}
                    />
                  ))}
                </Tabs>
              </Box>
              <div className='flex items-center justify-center'>
                <div className='w-[600px] h-[600px]'>
                  {home?.plan &&
                    (home?.plan?.link ||
                      home?.plan?.link2d ||
                      home?.plan?.location) && (
                      <ImagesSwiper
                        imageURLs={[
                          home?.plan?.link,
                          home?.plan?.link2d,
                          home?.plan?.location,
                        ]}
                      />
                    )}
                </div>
              </div>
            </div>

            <div className='bg-white !rounded-2xl !shadow-sm !p-4 min-w-[450px] text-sm [&>*]:my-1.5 [&>*>*:nth-child(2)]:text-sm [&>*>*:nth-child(2)]:font-bold'>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <div className='text-xl font-bold pb-3'>
                  {t('shaxmatka.moreHomeDetails.homeInfos')}
                </div>
              </Box>
              <div className='flex justify-between items-center'>
                <span className='text-[#64748B]'>
                  <i className='bi bi-buildings mr-2' />
                  {t('common.fields.simpleName')}:
                </span>
                <span className='text-[#1E293B]'>{home?.object?.name}</span>
              </div>
              <div className='flex justify-between items-center'>
                <span className='text-[#64748B]'>
                  <i className='bi bi-hash mr-2' />
                  {t('shaxmatka.homeDetail.houseNumber')}:
                </span>
                <span className='text-[#1E293B]'>№{home?.number}</span>
              </div>
              <div className='flex justify-between items-center'>
                <span className='text-[#64748B]'>
                  <i className='bi bi-door-open mr-2' />
                  {t('common.fields.rooms')}:
                </span>
                <span className='text-[#1E293B]'>{home?.rooms}&nbsp;X</span>
              </div>
              <div className='flex justify-between items-center'>
                <span className='text-[#64748B]'>
                  <div className='inline-block !-rotate-90 mr-2'>
                    <i className='bi bi-rulers' />
                  </div>
                  {t('shaxmatka.homeDetail.areaLive')}:
                </span>
                <span className='text-[#1E293B]'>
                  {home?.square}&nbsp;
                  <Trans i18nKey='common.global.meter'>
                    m<sup>2</sup>
                  </Trans>
                </span>
              </div>
              {Number(home?.terassa) == 0 ? (
                ''
              ) : (
                <div className='flex justify-between items-center'>
                  <span className='text-[#64748B]'>
                    <div className='inline-block !-rotate-90 mr-2'>
                      <i className='bi bi-rulers' />
                    </div>
                    {t('shaxmatka.homeDetail.areaTerrace')}:
                  </span>
                  <span>
                    {Number(home?.terassa)}&nbsp;
                    <Trans i18nKey='common.global.meter'>
                      m<sup>2</sup>
                    </Trans>
                  </span>
                </div>
              )}
              <div className='flex justify-between items-center'>
                <span className='text-[#64748B]'>
                  <i className='bi bi-crop mr-2' />
                  {Number(home?.terassa) == 0 ? 1 : Number(home?.square)}
                  &nbsp;
                  <Trans i18nKey='common.global.meter'>
                    m<sup>2</sup>
                  </Trans>
                  :
                </span>
                <span className='text-green-500'>
                  {homesData?.length === 1 ? (
                    <EditableNumberField
                      initialValue={priceForSquare}
                      changeFn={handleChangePriceSquare}
                      decimalScale={1}
                    >
                      <NumericFormat
                        value={priceForSquare}
                        allowNegative={false}
                        displayType={'text'}
                        thousandSeparator={' '}
                        decimalScale={1}
                        className='price-text !text-[#16BA5C]'
                        suffix={currency == '1' ? ' $' : ' UZS'}
                      />
                    </EditableNumberField>
                  ) : (
                    <NumericFormat
                      value={priceForSquare}
                      allowNegative={false}
                      displayType={'text'}
                      thousandSeparator={' '}
                      decimalScale={1}
                      className='price-text !text-[#16BA5C]'
                      suffix={currency == '1' ? ' $' : ' UZS'}
                    />
                  )}
                </span>
              </div>
              {Number(home?.terassa) == 0 ? (
                ''
              ) : (
                <div className='flex justify-between items-center'>
                  <span className='text-[#64748B]'>
                    <i className='bi bi-crop mr-2' />
                    {Number(home?.terassa)}&nbsp;
                    <Trans i18nKey='common.global.meter'>
                      m<sup>2</sup>
                    </Trans>
                    :
                  </span>
                  <span className='text-green-500'>
                    {homesData?.length === 1 && false ? (
                      <EditableNumberField
                        initialValue={terassaPriceForSquare}
                        changeFn={handleChangeTerassaPriceSquare}
                        decimalScale={1}
                      >
                        <NumericFormat
                          value={terassaPriceForSquare}
                          allowNegative={false}
                          displayType={'text'}
                          thousandSeparator={' '}
                          decimalScale={1}
                          className='price-text !text-[#16BA5C]'
                          suffix={currency == '1' ? ' $' : ' UZS'}
                        />
                      </EditableNumberField>
                    ) : (
                      <NumericFormat
                        value={terassaPriceForSquare}
                        allowNegative={false}
                        displayType={'text'}
                        thousandSeparator={' '}
                        decimalScale={1}
                        className='price-text !text-[#16BA5C]'
                        suffix={currency == '1' ? ' $' : ' UZS'}
                      />
                    )}
                  </span>
                </div>
              )}
              <div className='flex justify-between items-center'>
                <span className='text-[#64748B]'>
                  <i className='bi bi-cash mr-2' />
                  {t('shaxmatka.homeDetail.price')}:
                </span>
                <span className='text-green-500'>
                  {homesData?.length === 1 ? (
                    <EditableNumberField
                      initialValue={sellPrice}
                      changeFn={handleChangeSellPrice}
                      decimalScale={1}
                    >
                      <NumericFormat
                        value={sellPrice}
                        allowNegative={false}
                        displayType={'text'}
                        thousandSeparator={' '}
                        decimalScale={1}
                        className='price-text !text-[#16BA5C]'
                        suffix={currency == '1' ? ' $' : ' UZS'}
                      />
                    </EditableNumberField>
                  ) : (
                    <NumericFormat
                      value={home?.square * priceForSquare}
                      allowNegative={false}
                      displayType={'text'}
                      thousandSeparator={' '}
                      decimalScale={1}
                      className='price-text !text-[#16BA5C]'
                      suffix={currency == '1' ? ' $' : ' UZS'}
                    />
                  )}
                </span>
              </div>
              <div className='home-rooms-and-discount py-3'>
                <span className='home-data-divider mt-3'></span>
              </div>
              <div className='flex justify-between items-center'>
                <span className='text-[#64748B]'>
                  <i className='bi bi-list-check mr-2' />
                  {t('shaxmatka.homeDetail.repairType')}:
                </span>
                <div className='w-32'>
                  <Select fullWidth value={isrepaired} onChange={handleChange}>
                    <MenuItem value={0}>
                      {t('common.typeList.repairType.notRepaired')}
                    </MenuItem>
                    <MenuItem value={1}>
                      {t('common.typeList.repairType.repaired')}
                    </MenuItem>
                  </Select>
                </div>
              </div>
              <div className='pt-5'>
                <div>
                  {homesData?.length === 1 && (
                    <div className='flex items-center w-full'>
                      <DiscountPanel
                        setApplyDiscount={setApplyDiscount}
                        applyDiscount={applyDiscount}
                        home_id={homeData?.id}
                        formik={formik}
                      />
                    </div>
                  )}
                </div>
                <FormControlLabel
                  control={<IOSSwitch />}
                  labelPlacement='start'
                  label={t('settings.discounts.addDiscountModal.types.type1')}
                  sx={{
                    justifyContent: 'space-between',
                    marginLeft: '0',
                    width: '100%',
                    marginBottom: '8px',
                  }}
                  checked={startPriceTopOrder}
                  onChange={({ target }) =>
                    handleChangeStartPriceOrder(target?.checked)
                  }
                />
                <div className='grid grid-cols-2 gap-2 my-2.5'>
                  <SimpleNumberField
                    delay={0}
                    duration={0}
                    value={startPrice}
                    setValue={handleChangeStartPrice}
                    label={t('common.fields.startPrice')}
                    name='startPrice'
                    className='!bg-white'
                    size='small'
                  />
                  <SimpleNumberField
                    delay={0}
                    duration={0}
                    value={startPricePercentage}
                    setValue={handleChangeStartPricePercent}
                    label={t('common.fields.startPricePercentage')}
                    name='startPrice'
                    className='!bg-white'
                    size='small'
                  />
                </div>
                <div className='my-2.5'>
                  <SimpleNumberField
                    delay={0}
                    duration={0}
                    value={priceForMonth}
                    setValue={handleChangePriceForMonth}
                    label={t('shaxmatka.homeDetail.monthlyPay')}
                    name='startPrice'
                    className='!bg-white'
                    size='small'
                  />
                </div>

                <div className='grid grid-cols-2 gap-2 my-2.5'>
                  <SimpleNumberField
                    delay={0}
                    duration={0}
                    value={lastPayment}
                    setValue={handleChangeLastPayment}
                    label={t('common.fields.lastPayment')}
                    name='startPrice'
                    className='!bg-white'
                    size='small'
                  />
                  <SimpleNumberField
                    delay={0}
                    duration={0}
                    value={lastPaymentPercentage}
                    setValue={handleChangeLastPaymentPercentage}
                    label={t('common.fields.lastPaymentPercentage')}
                    name='startPrice'
                    className='!bg-white'
                    size='small'
                  />
                </div>

                <div className='mb-5'>
                  <SimpleNumberField
                    delay={0}
                    duration={0}
                    value={month}
                    setValue={handleChangeMonth}
                    label={t('shaxmatka.moreHomeDetails.month')}
                    className='!bg-white !mt-3.5'
                    placeholder={t('shaxmatka.moreHomeDetails.type')}
                    name='monthValue'
                    size='small'
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName='.Mui-focusVisible' disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#65C466',
        opacity: 1,
        border: 0,
        ...theme.applyStyles('dark', {
          backgroundColor: '#2ECA45',
        }),
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.grey[100],
      ...theme.applyStyles('dark', {
        color: theme.palette.grey[600],
      }),
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
      ...theme.applyStyles('dark', {
        opacity: 0.3,
      }),
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: '#E9E9EA',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
    ...theme.applyStyles('dark', {
      backgroundColor: '#39393D',
    }),
  },
}));
